var acc = document.getElementsByClassName("accordion");
for (var i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    Array.prototype.forEach.call(
      document.getElementsByClassName("accordion"),
      function (el) {
        el.classList.remove("active");
      }
    );
    Array.prototype.forEach.call(
      document.getElementsByClassName("panel"),
      function (el) {
        el.classList.remove("actives");
      }
    );
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
      panel.classList.remove("actives");
      this.classList.remove("active");
    } else {
      Array.prototype.forEach.call(
        document.getElementsByClassName("panel"),
        function (el) {
          el.style.maxHeight = null;
        }
      );
      panel.classList.add("actives");
      this.classList.add("active");
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

var innerTitles = document.getElementsByClassName("acc__title--inner");
for (var j = 0; j < innerTitles.length; j++) {
  innerTitles[j].addEventListener("click", function () {
    var innerPanel = this.nextElementSibling;
    var card = this.parentElement;
    var parentPanel = card.closest(".panel.actives");

    if (innerPanel.style.maxHeight && innerPanel.style.maxHeight !== "0px") {
      innerPanel.style.maxHeight = "0px";
      card.classList.remove("active");
    } else {
      innerPanel.style.maxHeight = innerPanel.scrollHeight + "px";
      card.classList.add("active");
    }

    // Set parent to huge value so it never clips, then settle to exact height after transition
    if (parentPanel) {
      parentPanel.style.maxHeight = "9999px";
      innerPanel.addEventListener("transitionend", function onDone() {
        innerPanel.removeEventListener("transitionend", onDone);
        parentPanel.style.maxHeight = parentPanel.scrollHeight + "px";
      });
    }
  });
}

window.addEventListener("load", function () {
  document.querySelectorAll(".accordion.active").forEach(function (element) {
    element.click();
  });
});